document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-menu-toggle]').forEach(btn=>btn.addEventListener('click',()=>{
    const nav=document.querySelector('[data-nav]'); if(nav) nav.classList.toggle('is-open');
  }));
  document.querySelectorAll('[data-slider]').forEach(slider=>{
    const slides=[...slider.querySelectorAll('[data-slide]')];
    const dots=[...slider.querySelectorAll('[data-dot]')];
    if(slides.length<2)return;
    let i=0; const show=n=>{slides.forEach((s,x)=>s.classList.toggle('is-active',x===n));dots.forEach((d,x)=>d.classList.toggle('is-active',x===n));i=n};
    dots.forEach((d,x)=>d.addEventListener('click',()=>show(x)));
    setInterval(()=>show((i+1)%slides.length),5500);
  });
  document.querySelectorAll('[data-zip-checker]').forEach(box=>{
    const input=box.querySelector('[data-zip-input]'),btn=box.querySelector('[data-zip-btn]'),out=box.querySelector('[data-zip-result]');
    const allowed=(box.dataset.zips||'').split(',').map(x=>x.trim()).filter(Boolean);
    if(!btn)return; btn.addEventListener('click',()=>{const z=(input.value||'').trim(); if(!/^\d{5}$/.test(z)){out.textContent='Please enter a 5-digit ZIP code.';return} out.textContent=allowed.includes(z)?"✓ You're in our service area.":"Contact EcoLoop and we'll confirm availability.";});
  });
  const popup=document.querySelector('[data-promo-popup]');
  if(popup){const key='ecoloopPromoDismissed';const sessionKey='ecoloopPromoShown';const delay=parseInt(popup.dataset.delay||'2000',10);if(!localStorage.getItem(key)&&!sessionStorage.getItem(sessionKey)){setTimeout(()=>{popup.classList.add('is-open');sessionStorage.setItem(sessionKey,'1')},delay)};popup.querySelectorAll('[data-popup-close]').forEach(x=>x.addEventListener('click',()=>{popup.classList.remove('is-open');localStorage.setItem(key,'1')}));document.addEventListener('keydown',e=>{if(e.key==='Escape')popup.classList.remove('is-open')});}
});

/* Purchase options: single-select + live price (fixes Subscriptions app widget radios) v2 */
(function(){
  function money(t){ var m = (t||'').match(/\$[\d,]+\.\d{2}/); return m ? m[0] : null; }
  function findOpts(){
    var sels = ['input[data-radio-type]','input[data-selling-plan-id]','input[data-variant-id]',
      '.shopify-subscriptions input[type="radio"]','[id*="subscription"] input[type="radio"]',
      '.purchase-options input[type="radio"]','form.product-form input[type="radio"]'];
    var found = [];
    sels.forEach(function(s){
      try{ document.querySelectorAll(s).forEach(function(i){ if(found.indexOf(i)<0) found.push(i); }); }catch(e){}
    });
    return found.filter(function(i){ return i.type==='radio'||i.type==='checkbox'; });
  }
  function wire(opts){
    var priceEl = document.querySelector('.product-price');
    opts.forEach(function(input){
      if(input._ecoWired) return; input._ecoWired = true;
      input.addEventListener('click', function(){
        opts.forEach(function(o){ if(o!==input) o.checked = false; });
        input.checked = true;
        var label = input.closest('label') || input.parentElement;
        var p = label && money(label.textContent);
        if(p && priceEl) priceEl.textContent = p;
      });
    });
  }
  function check(){ var o = findOpts(); if(o.length>=2) wire(o); }
  if(document.body){
    new MutationObserver(check).observe(document.body, {childList:true, subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();

/* Promo popup v2 — 20% first order */
document.addEventListener('DOMContentLoaded',()=>{
  const p2=document.querySelector('[data-promo-popup-v2]');
  if(!p2) return;
  const key='ecoloopPromoV2Dismissed', skey='ecoloopPromoV2Shown';
  const delay=parseInt(p2.dataset.delay||'3000',10);
  if(!localStorage.getItem(key)&&!sessionStorage.getItem(skey)){
    setTimeout(()=>{p2.classList.add('is-open');sessionStorage.setItem(skey,'1')},delay);
  }
  p2.querySelectorAll('[data-popup2-close]').forEach(x=>x.addEventListener('click',()=>{p2.classList.remove('is-open');localStorage.setItem(key,'1')}));
  p2.addEventListener('click',e=>{if(e.target===p2){p2.classList.remove('is-open');localStorage.setItem(key,'1')}});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')p2.classList.remove('is-open')});
});
